// src/ChatBubble.js
import React from "react";

function formatMessage(text) {
  // Replace line breaks
  let formatted = text.replace(/\n/g, "<br />");

  // Replace **bold** markers
  formatted = formatted.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");

  // Auto-link URLs
  formatted = formatted.replace(
    /(https?:\/\/[^\s<]+)/g,
    (url) => {
      try {
        const parsed = new URL(url);
        const display = parsed.hostname.replace("www.", "");
        return `<a href="${url}" target="_blank" rel="noopener noreferrer">${display}</a>`;
      } catch {
        return url; // fallback for malformed URLs
      }
    }
  );

  return formatted;
}

const ChatBubble = ({ sender, text }) => {
  const isUser = sender === "user";
  return (
    <div className={`chat-bubble ${isUser ? "user" : "bot"}`}>
      <div
        className="bubble"
        dangerouslySetInnerHTML={{ __html: formatMessage(text) }}
      />
    </div>
  );
};

export default ChatBubble;
